import React from 'react';
import { useNavigate } from 'react-router-dom';
import { PageContainer, MainContainer } from '../../ui';
import { ArbiWinHeader, ArbiWinFooter } from '../../ui';
import RegisterForm from './RegisterForm.jsx';

/**
 * RegisterPage - Full page component for user registration
 * Uses the same layout structure as LoginPage
 */
const RegisterPage = function RegisterPage() {
  const navigate = useNavigate();
  
  return (
    <PageContainer>
      <ArbiWinHeader 
        isAuthenticated={false}
        onLogin={() => navigate('/login')}
        onRegister={() => navigate('/register')}
        onHomeClick={() => navigate('/')}
      />
      <MainContainer>
        <div style={{ maxWidth: 480, margin: '0 auto', padding: 'var(--spacing-8) var(--spacing-4)' }}>
          <RegisterForm />
        </div>
      </MainContainer>
      <ArbiWinFooter />
    </PageContainer>
  );
};

RegisterPage.displayName = 'RegisterPage';

export default RegisterPage;
